import * as React from "react";
const SvgFiRrBootHeeled = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-boot-heeled_svg__a)">
      <path
        fill="#062147"
        d="m20.683 15.724-5.578-2.79A1.99 1.99 0 0 1 14 11.147V4c0-1.234-.556-2.38-1.526-3.143A3.98 3.98 0 0 0 9.061.113L3.826 1.378A4.986 4.986 0 0 0 0 6.238V22c0 1.103.897 2 2 2h5c1.103 0 2-.897 2-2v-1.444c.068.04.139.072.205.116l3.48 2.32A6 6 0 0 0 16.013 24h5.077A2.913 2.913 0 0 0 24 21.09a5.97 5.97 0 0 0-3.317-5.367M7 22H2v-2h5zm14.09 0h-5.077c-.792 0-1.56-.232-2.219-.672l-3.48-2.32A6 6 0 0 0 6.986 18H2V6.238c0-1.391.944-2.59 2.295-2.916L6 2.91v7.089a1 1 0 0 0 2 0V2.427l1.53-.37a1.98 1.98 0 0 1 1.707.373c.485.38.763.954.763 1.57v7.146a3.98 3.98 0 0 0 2.211 3.578l5.578 2.789A3.98 3.98 0 0 1 22 21.09a.91.91 0 0 1-.91.909"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-boot-heeled_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBootHeeled;
